export const EDIT_GUARANTOR = 'page/EDIT_GUARANTOR';
export const EDITING_GUARANTOR = 'page/EDITING_GUARANTOR';
export const EDIT_GUARANTOR_LEAVE = 'page/EDIT_GUARANTOR [leave]';
